/**
 * nbd-pixel-events.js — NBD Powerlifting
 * =========================================================================
 * DISABLED — 11 Aug 2026
 *
 * WHY THIS FILE IS NOW EMPTY
 * --------------------------
 * This file used to fire fbq('track','AddToCart') and fbq('track','InitiateCheckout')
 * directly from the theme. The Shopify "Facebook & Instagram" sales channel ALREADY
 * fires both of those events through its own web pixel, on the same pixel ID
 * (1147121249910569), with its own eventID (prefixed "sh-").
 *
 * Because the two eventIDs never matched, Meta could not deduplicate them.
 * Result: every AddToCart and every InitiateCheckout was counted TWICE.
 *
 * Verified live on 11 Aug 2026 — one Add-to-Cart click produced:
 *   fbq('track','AddToCart', ..., {eventID:'nbd_msnlpx5r_36g0634'})              <- this file
 *   fbq('trackShopify','1147121249910569','AddToCart', ..., {eventID:'sh-...'})  <- Shopify channel
 *
 * The Shopify channel event is the correct one to keep: it is paired server-side
 * (Conversions API) and deduplicates properly. This file was the duplicate.
 *
 * The functions below are kept as harmless no-ops so that any theme section or
 * snippet still calling nbdPixelATC() / nbdPixelCheckout() does not throw.
 *
 * DO NOT re-run scripts/tracking/meta-pixel-tracking.py — it redeploys the duplicate.
 * Original saved at backups/nbd-pixel-events.LIVE-backup-20260811-010754.js
 * =========================================================================
 */

(function () {
  'use strict';

  /* No-ops. Meta events are handled entirely by the Shopify
     Facebook & Instagram sales channel web pixel. */
  window.nbdPixelATC = function () {};
  window.nbdPixelCheckout = function () {};

})();
